module.exports = __webpack_public_path__ + "media/Speaker_waveform.4146ba1d.mp4";